module.exports = __webpack_public_path__ + "img/login-background.7bab8b55.jpg";